import {
  BooleanField,
  Button,
  Datagrid,
  EditButton,
  Filter,
  List,
  NumberField,
  ResourceComponentInjectedProps,
  ShowButton,
  TextField,
  TextInput,
  useRecordContext,
} from 'react-admin';
import { FC, useState } from 'react';

import { AdminGetUserResponseDto } from 'api/generated';
import BlockIcon from '@mui/icons-material/Block';
import { Drawer } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import UsersBanForm from '../UsersBanForm/UsersBanForm';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  button: { color: 'red' },
});

const UsersList = () => {
  const [bannedUser, setBannedUser] = useState<AdminGetUserResponseDto | null>(null);

  const UsersFilter: FC<ResourceComponentInjectedProps> = (props) => (
    <Filter {...props}>
      <TextInput label="Поиск по никнейму" source="nickname" alwaysOn />
      <TextInput label="Поиск по имени" source="profile.name" alwaysOn />
      <TextInput label="Поиск по фамилии" source="profile.surname" alwaysOn />
    </Filter>
  );
  const handleClose = () => {
    setBannedUser(null);
  };

  const BanButton = () => {
    const styles = useStyles();
    const record = useRecordContext<AdminGetUserResponseDto>();

    return (
      <Button
        className={!record.isBlocked ? styles.button : undefined}
        onClick={() => setBannedUser(record)}
        label={record.isBlocked ? 'Разблокировать' : 'Заблокировать'}
        startIcon={record.isBlocked ? <LockOpenIcon /> : <BlockIcon />}
      />
    );
  };

  return (
    <List filters={<UsersFilter />}>
      <Datagrid bulkActionButtons={false}>
        <TextField label="Имя" source="profile.name" />
        <TextField label="Фамилия" source="profile.surname" />
        <TextField label="Никнейм" source="nickname" />
        <BooleanField label="Галочка" source="profile.verified" />
        <BooleanField label="Заблокирован" source="isBlocked" />
        <NumberField label="Приоритет" source="profile.priority" />
        <ShowButton />
        <EditButton />
        <BanButton />
        <Drawer variant="persistent" open={!!bannedUser?.id} anchor="right" onClose={handleClose}>
          {!!bannedUser?.id && <UsersBanForm onCancel={handleClose} record={bannedUser} />}
        </Drawer>
      </Datagrid>
    </List>
  );
};

export default UsersList;
